(function () {
  function initStickyBar() {
    var sticky = document.querySelector('[data-slc-mobile-sticky]');
    var form = document.querySelector('.slc-form');
    if (!sticky || !form || sticky.dataset.slcReady === 'true') return;

    sticky.dataset.slcReady = 'true';
    form.addEventListener('focusin', function () {
      if (window.matchMedia('(max-width: 860px)').matches) sticky.hidden = true;
    });
    form.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!form.contains(document.activeElement)) sticky.hidden = false;
      }, 80);
    });
  }

  document.addEventListener('DOMContentLoaded', initStickyBar);
  document.addEventListener('shopify:section:load', initStickyBar);
})();
